export default __webpack_public_path__ + "static/media/pdc_mobility_step5.a2444407.svg";